<template>
  <el-form class="mail-control" :model="control" label-width="70px">
    <el-form-item prop="name">
      <template slot="label">
        <span class="require-flag">*</span>
        名称
      </template>
      <el-input v-model="control.name"></el-input>
    </el-form-item>
    <el-form-item prop="hint">
      <template slot="label">
        提示
      </template>
      <el-input v-model="control.hint"></el-input>
    </el-form-item>
    <el-form-item prop="description">
      <template slot="label">
        描述
      </template>
      <el-input v-model="control.description"></el-input>
    </el-form-item>
    <el-form-item prop="required">
      <template slot="label">
        必填
      </template>
      <el-checkbox v-model="control.required" :disabled="control.main"></el-checkbox>
    </el-form-item>
    <el-form-item prop="display">
      <template slot="label">
        显示
      </template>
      <el-checkbox v-model="control.display" :disabled="control.main"></el-checkbox>
    </el-form-item>
    <el-form-item prop="disabled">
      <template slot="label">
        不可编辑
      </template>
      <el-checkbox v-model="control.disabled"></el-checkbox>
    </el-form-item>
    <el-form-item prop="main">
      <template slot="label">
        标题
      </template>
      <el-checkbox v-model="control.main" @change="checkChange($event)"></el-checkbox>
    </el-form-item>
    <el-form-item prop="main">
      <template slot="label">
        唯一
      </template>
      <el-checkbox v-model="control.unique"></el-checkbox>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: "mail-control",
  props: {
    control: Object
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    checkChange(value) {
      this.$emit("checkboxChange", "main", value)
    }
  }
}
</script>

<style lang="scss" scoped>
.mail-control {
}
</style>
